
import { ActionTree } from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';

export const actions: ActionTree<any, any> = {

    loadFeedback: ({state, getters, commit, dispatch}, {locale, force}) => {

        if (force) {
            state.feedbackCacheExpires = null;
        }

        return new Promise((resolve, reject) => {

            // Pull from store if loaded and cache hasn't expired
            if (state.feedbackCacheExpires === null || moment().isAfter(state.feedbackCacheExpires)) {

                commit('setFeedbackLoading', true);

                let url = locale ? '/feedback/' + locale : '/feedback';

                axios.get(url)

                    .then((response: AxiosResponse) => {
                        commit('setFeedbackData', response.data);
                        commit('setFeedbackLoading', false);
                        resolve(response.data);
                    })
                    .catch((error: AxiosError) => {
                        commit('setFeedbackLoading', false);
                        reject(error);
                    });
            } else {
                resolve(state.data);
            }
        });
    },
};
